import CustomConfirmationDialog from '../../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog';
import { withStyles, CircularProgress } from '@material-ui/core';
import { useState, useEffect, useRef } from 'react';
import { getWarningMessageForEditFlow, getHolidayValidationDetails } from './../utils';
import { constants } from '../constants';
import styles from './WarningConfirmationDialogStyles';

const EditHolidayConfirmationDialog = (props) => {
  const [holidayValidationMessage, setHolidayValidationMessage] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const isMounted = useRef(true);
  const isCustomerAssignedToHolidayRef = useRef(false);

  useEffect(() => {
    validateHoliday();
    return () => {
      isMounted.current = false;
    };
  }, []);

  const validateHoliday = () => {
    getHolidayValidationDetails(props.holidayDetails.holidayId).then((response) => {
      if (!isMounted.current) {
        return;
      }
      handleHolidayValidationWarning(response?.data ?? []);
    });
  };

  const handleHolidayValidationWarning = (assignedCustomerTerminals = []) => {
    const message = getWarningMessageForEditFlow({...props, assignedCustomerTerminals});
    isCustomerAssignedToHolidayRef.current = Boolean(assignedCustomerTerminals.length);
    setHolidayValidationMessage(message);
    setIsLoading(false);
  };

  return (
    <CustomConfirmationDialog
      title="Update Holiday"
      cancelButtonLabel="Cancel"
      confirmButtonLabel="Update"
      onConfirm={props.onConfirm}
      disabled={isLoading || holidayValidationMessage}
      onCancel={props.onCancel}>
      <div className={props.classes.loaderContainer}>
        {isLoading && (
          <>
            <CircularProgress size={24} className={props.classes.loader} />
            <span>{constants.MESSAGE.HOLIDAY_VALIDATION_INPROGRESS}</span>
          </>
        )}
        {!isLoading && holidayValidationMessage && (
          <div>
            {holidayValidationMessage}
            <br />
            <br />
            {constants.MESSAGE.CUSTOMER_ASSIGNED_EDIT}
          </div>
        )}
        {!isLoading && !holidayValidationMessage && (
          <div>
            {!isCustomerAssignedToHolidayRef.current && (
              <span className={props.classes.noCustomer}>
                {constants.MESSAGE.NO_ASSIGNED_CUSTOMER}
              </span>
            )}
            <div className={props.classes.messageContainer}>
              {`Are you sure you want to update the details for the selected holiday, '${props.holidayDetails.holidayName}'?`}
            </div>
          </div>
        )}
      </div>
    </CustomConfirmationDialog>
  );
};

export default withStyles(styles)(EditHolidayConfirmationDialog);
